import { PcApiResponse } from '@/api/pc-api/types';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type CompanySummary = {
  companyInfo: {
    id?: string;
    businessClassification: string;
    businessNumber: string;
    name?: string;
    representativeName?: string;
    businessCategory?: string;
    businessCategoryItem?: string;
    baseAddress?: string;
    detailAddress?: string;
    zipcode?: string;
  };
  /** 앱을 사용하지 않는 BIZ(마이데이터, 모바일전자증명)는 내려오지 않음 */
  appInfo?: {
    appId: string;
    appName: string;
  };
  /** 모바일전자증명 이용기관의 추가 정보 */
  extraInfo?: {
    platformId?: string;
    clientId?: string;
  };
};

/**
 * 사업자 정보 / 앱 정보 / 추가 정보를 한 번에 조회한다.
 * (기존 /v1/{authInfoId}/company, /v1/{authInfoId}/app 대체)
 */
export const getCompanySummary = (targetId: string) => {
  return api<PcApiResponse<CompanySummary>>('get', `/pc-api/v1/${PREFIX_PATH}/company/summary`, { targetId });
};
